import React, { useState, useEffect } from "react";
import "./App.css";

const directoryContents = [
  "About",
  "Contact",
  "Projects",
  "Achievements",
  "Education",
];

const contentMap = {
  About: "Add your About content here",
  Contact: "Add your Contact content here",
  Projects: "Add your Projects content here",
  Achievements: "Add your Achievements content here",
  Education: "Add your Education content here",
};

function App() {
  const [name, setName] = useState("@Sarvesh-MAC");
  const [currentDirectory, setCurrentDirectory] = useState("");
  const [commandHistory, setCommandHistory] = useState([]);
  const [currentCommandIndex, setCurrentCommandIndex] = useState(-1);
  const [commandInput, setCommandInput] = useState("");

  const handleCommand = (command) => {
    switch (command) {
      case "name":
        setName("@Sarvesh-MAC");
        break;
      case "ls":
        if (currentDirectory === "") {
          setCurrentDirectory(directoryContents.join("\n"));
        } else if (currentDirectory === "Education") {
          setCurrentDirectory("About\nAchievements\nProjects");
        } else {
          setCurrentDirectory("");
        }
        break;
      case "clear":
        setCommandHistory([]);
        setCurrentCommandIndex(-1);
        setCurrentDirectory("");
        break;
      case "cd ..":
        setCurrentDirectory("");
        break;
      default:
        if (
          command.startsWith("cd ") &&
          directoryContents.includes(command.substring(3))
        ) {
          setCurrentDirectory(command.substring(3));
        } else {
          setCurrentDirectory("");
        }
        break;
    }
    if (command !== "clear") {
      setCommandHistory([...commandHistory, command]);
      setCurrentCommandIndex(commandHistory.length);
    }
    setCommandInput("");
  };

  const handleInputChange = (e) => {
    setCommandInput(e.target.value);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter") {
      handleCommand(commandInput.trim());
    } else if (e.key === "ArrowUp") {
      if (currentCommandIndex > 0) {
        setCurrentCommandIndex(currentCommandIndex - 1);
        setCommandInput(commandHistory[currentCommandIndex - 1]);
      }
    } else if (e.key === "ArrowDown") {
      if (currentCommandIndex < commandHistory.length - 1) {
        setCurrentCommandIndex(currentCommandIndex + 1);
        setCommandInput(commandHistory[currentCommandIndex + 1]);
      } else if (currentCommandIndex === commandHistory.length - 1) {
        setCurrentCommandIndex(-1);
        setCommandInput("");
      }
    }
  };
  useEffect(() => {
    const terminalBody = document.querySelector(".terminal-body");
    terminalBody.scrollTop = terminalBody.scrollHeight;
  }, [commandHistory]);

  return (
    <div className="terminal">
      <div className="terminal-header">
        <span className="terminal-title">{name} Portfolio </span>
      </div>

      <div className="terminal-body">
        <p className="terminal-base">Welcome to my portfolio terminal!</p>
        <p>Use Commands like ls,cd,clear,cd .. otherwise it comes invalid</p>
        <br/>
        {commandHistory.map((command, index) => {
          const isLsCommand = command.startsWith("ls");
          const isCdCommand = command.startsWith("cd ");
          const isCdEducationCommand = command === "cd Education";
          const isCdAboutCommand = command === "cd Achivements";
          const isCdProjectsCommand = command === "cd Projects";
          const isCdContactCommand = command === "cd Contact";
          // const isEducationDirectory = currentDirectory === "Education";
          // const isAboutDirectory = currentDirectory === "About";
          // const isProjectsDirectory = currentDirectory === "Projects";
          // const isContactDirectory = currentDirectory === "Contact";
          const isRootDirectory = currentDirectory === "";

          return (
            <div key={index}>
              <span>{`${name} ${
                isRootDirectory ? "" : currentDirectory
              } %`}</span>

              <span className="prompt">{` ${command}`}</span>
              <br />
              {isLsCommand && isRootDirectory && (
                <div>
                  <span>{`${name}${currentDirectory} %`}</span>

                  {directoryContents.map((directory) => (
                    <div key={directory}>{directory}</div>
                  ))}
                </div>
              )}

              {/* {isLsCommand && isEducationDirectory && (
                <div>
                  <span>10th</span>
                  <br />
                  <span>12th</span>
                  <br />
                  <span>UG</span>
                </div>
              )}
              {isLsCommand && isAboutDirectory && (
                <div>
                  <span>About</span>
                  <br />
                  <span>Achivements</span>
                  <br />
                  <span>Projects</span>
                </div>
              )}

              {isLsCommand && isProjectsDirectory && (
                <div>
                  <span>About</span>
                  <br />
                  <span>Achivements</span>
                  <br />
                  <span>Projects</span>
                </div>
              )}
              {isLsCommand && isContactDirectory && (
                <div>
                  <span>About</span>
                  <br />
                  <span>Achivements</span>
                  <br />
                  <span>Projects</span>
                </div>
              )} */}

              {isCdCommand && (
                <span>
                  {isCdEducationCommand ? `$ ${currentDirectory}` : command}
                </span>
              )}
              {index === commandHistory.length - 1 && isCdEducationCommand && (
                <div className="content">
                  <h2>Education</h2>
                  <p>10th - Wisdomland Matriculation School.</p>
                  <p>89.6 Percentage</p>
                  <br />
                  <p>12th - Sri Vijay Vidyalaya Matric Hr Sec School.</p>
                  <p>78.9 Percentage</p>
                  <br />
                  <p>UG - Bannari Amman Institute of Technology.</p>
                  <p>9.00 CGPA</p>
                  <br />
                </div>
              )}
              {index === commandHistory.length - 1 && isCdAboutCommand && (
                <div className="content">
                  <h2>Achievements</h2>
                  <p>Winner of Smart India Hackathon(SIH) 2022.</p>
                  <p>Cash Price ₹1,00,000</p>
                </div>
              )}
              {index === commandHistory.length - 1 && isCdProjectsCommand && (
                <div className="content">
                  <h2>Projects</h2>
                  <p>AI Enabled Aqua Scooper Boat.</p>
                  <p>toDoList</p>
                  <p>SarveshSphere</p>
                  <p>Terminal Portfolio</p>
                </div>
              )}
              {index === commandHistory.length - 1 && isCdContactCommand && (
                <div className="content">
                  <h2>Contact</h2>
                  <p>Mobile - 7010498176 </p>
                  <p>Mail - gokulsarvehsk@gmail.com .</p>
                </div>
              )}
              {index === commandHistory.length - 1 &&
                !isCdCommand &&
                !isLsCommand && (
                  <span style={{ color: 'red' }}>{contentMap[command] || "Invalid command"}</span>

                )}
            </div>
          );
        })}
        {/* Display the current directory */}
        <div>
          <span>{`${name} ${currentDirectory ? currentDirectory : ""} %`}</span>
        </div>
        <div className="terminal-prompt">
          <span className="prompt">`$ {name} %`</span>
          <input
            type="text"
            autoFocus
            value={commandInput}
            onChange={handleInputChange}
            onKeyDown={handleInputKeyDown}
          />
        </div>
      </div>
      <a href="https://sarvesh-react-portfolio.netlify.app" className="loader">Gokulsarvesh</a>

    </div>
  );
}

export default App;
